"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDateValueFromOptimized = exports.generateDateFieldValue = exports.getDateFieldEmptyValue = void 0;
const getDateFieldEmptyValue = () => ({
    date: null,
    include_time: false,
});
exports.getDateFieldEmptyValue = getDateFieldEmptyValue;
const generateDateFieldValue = (value) => {
    return { ...(0, exports.getDateFieldEmptyValue)(), ...value };
};
exports.generateDateFieldValue = generateDateFieldValue;
const getDateValueFromOptimized = (fieldValue) => {
    const includeTime = fieldValue.includes("T");
    return {
        date: includeTime ? fieldValue : `${fieldValue}T00:00:00.000+00:00`,
        include_time: includeTime,
    };
};
exports.getDateValueFromOptimized = getDateValueFromOptimized;
